export const promoPlatformsEntityTranslationKeys = {
  promoMediaTypeGIF: 'promo.media_type__gif',

  promoMediaTypeHTML: 'promo.media_type__html',
  promoMediaTypeImage: 'promo.media_type__image',
  statisticsPlatformLabel: 'statistics.platform-label',
}
